exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header[data-v-5a0aca66]{display:flex;flex-direction:row;height:15%;width:100%;border:.15rem solid #000;background-color:#ccd5ae}#logo[data-v-5a0aca66]{display:inline-block;min-width:20%;height:100%}img[data-v-5a0aca66]{margin:1%;width:100%;height:100%;cursor:pointer}div[data-v-5a0aca66]{display:flex;flex-direction:column;width:100%}ul[data-v-5a0aca66]{display:flex;flex-direction:row;align-items:flex-start;list-style-type:none}li[data-v-5a0aca66]{font-size:1.2rem;margin:0 1.3rem 0 1.2rem;cursor:pointer}a[data-v-5a0aca66]{text-decoration:none}a[data-v-5a0aca66]:visited{color:#000}@media only screen and (max-width:768px){header[data-v-5a0aca66]{width:95vw;flex-direction:column}img[data-v-5a0aca66]{width:40vw;height:8vh}ul[data-v-5a0aca66]{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a0aca66","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Navbar.vue
// module id = 36
// module chunks = 0